module.exports = __webpack_public_path__ + "static/media/xplane.69577580.png";